<template>
  <div class="box text-center">
    <!-- /.box-header -->
    <div class="box-body form">
      <div class="del-block" v-if="show.delBtn">
        <div class="btn btn-danger" data-toggle="modal" data-target="#delModal">刪除帳號</div>
      </div>
      <br  v-if="show.delBtn" />
      <br />
      <!-- cr start-->
      <div v-if="!info">
        <div class="input-group">
          <span class="input-group-addon b-r">
            <span class="text-red">＊ </span>角色
          </span>
          <div class="form-group text-left">
            <div class="radio inline-block">
              <label>
                <input type="radio" name="roleTypeOption" value="admin" v-model="radioRoleType">系統
              </label>
            </div>
            <div class="radio inline-block">
              <label>
                <input type="radio" name="roleTypeOption" value="brand" v-model="radioRoleType">品牌
              </label>
            </div>
            <div class="radio inline-block">
              <label>
                <input type="radio" name="roleTypeOption" value="store" v-model="radioRoleType">店家
              </label>
            </div>
            <div class="radio inline-block">
              <label>
                <input type="radio" name="roleTypeOption" value="pos" v-model="radioRoleType">POS
              </label>
            </div>
          </div>
        </div>
        <br />
      </div>
      <div v-if="!info">
        <div class="input-group">
        <span class="input-group-addon">
          <span class="text-red">＊ </span>帳號
        </span>
          <input class="form-control" placeholder="" type="text" v-model="content.account" maxlength="45">
        </div>
        <br />
      </div>
      <!-- up start -->
      <div v-if="info">
        <div class="input-group">
          <span class="input-group-addon">帳號</span>
          <div class="form-control form-info text-left">
            {{info.account}}
          </div>
        </div>
        <br />
      </div>
      <!-- up end-->
      <div>
        <div class="input-group">
        <span class="input-group-addon" v-if="!info">
          <span class="text-red">＊ </span>密碼
        </span>
        <span class="input-group-addon" v-if="info">
          新密碼
        </span>
          <input class="form-control" placeholder="" type="password" v-model="content.password" maxlength="20" minlength="6">
        </div>
        <br />
      </div>
      <div>
        <div class="input-group">
        <span class="input-group-addon" v-if="!info">
          <span class="text-red">＊ </span>密碼確認
        </span>
        <span class="input-group-addon" v-if="info">
          新密碼確認
        </span>
          <input class="form-control" placeholder="" type="password" v-model="content.re_password"
                 maxlength="20" minlength="6">
          <span class="form-group__message" v-if="!$v.content.re_password.sameAsPassword">密碼不正確</span>
        </div>
        <br />
      </div>
      <!-- cr end-->
      <div>
        <div class="input-group">
        <span class="input-group-addon">
          <span class="text-red">＊ </span>名稱
        </span>
          <input class="form-control" placeholder="" type="text" v-model="content.name" maxlength="20">
        </div>
        <br />
      </div>
      <div v-if="radioRoleType === 'brand' || $route.params.role_type === 'brand'">
        <div class="input-group">
        <span class="input-group-addon">
          <span class="text-red">＊ </span>品牌綁定
        </span>
          <multiselect v-model="select.bindingBrandList" tag-placeholder="品牌綁定"
                       placeholder="選擇品牌" label="label" track-by="value" :options="brandBrief"
                       :multiple="true" :allow-empty="false"></multiselect>
          <!--<v-select v-model="content.bindingBrandList" :options="brandBrief" class="h-38"></v-select>-->
        </div>
        <br />
      </div>
      <div v-if="radioRoleType === 'store' || $route.params.role_type === 'store'">
        <div class="input-group">
        <span class="input-group-addon">
          <span class="text-red">＊ </span>品牌
        </span>
          <!-- <select class="form-control" v-model="brandDefault">
            <option :value="brand.value" v-for="brand in brandBrief">
              {{brand.label}}
            </option>
          </select> -->
            <multiselect
            v-model="brandDefault"
            :options="brandBrief"
            :searchable="true"
            :allow-empty="false"
            :close-on-select="true"
            placeholder="== 品牌 =="
            :show-labels="false"
            :multiple="false"
            label="label"
            track-by="value"
          >
          </multiselect>
        </div>
        <br />
      </div>
      <div v-if="radioRoleType === 'store' || $route.params.role_type === 'store'">
        <div class="input-group">
        <span class="input-group-addon">
          <span class="text-red">＊ </span>店家綁定
        </span>
          <multiselect v-model="select.bindingStoreList" tag-placeholder="店家綁定"
                       placeholder="選擇店家" label="label" track-by="value" :options="storeBrief"
                       :multiple="true" :allow-empty="false"></multiselect>
          <!--<v-select v-model="content.bindingStoreList" :options="storeBrief" class="h-38"></v-select>-->
        </div>
        <br />
      </div>
      <div v-if="radioRoleType === 'pos' || $route.params.role_type === 'pos'">
        <div class="input-group">
        <span class="input-group-addon">
          <span class="text-red">＊ </span>POS廠ID綁定
        </span>
          <multiselect v-model="select.bindingPosList" tag-placeholder="POS綁定"
                       placeholder="選擇POS" label="label" track-by="value" :options="posBrief"
                       :multiple="false" :allow-empty="false"></multiselect>
        </div>
        <br />
      </div>
      <div>
        <div class="input-group form-group m-y-0">
          <span class="input-group-addon form__label">
            手機號碼
          </span>
          <input class="form-control form__input" placeholder="" type="tel"
                 v-model.trim="content.phone" maxlength="10"
                 @input="$v.content.phone.$touch()"
                 @keyup="verityPhone()" id="phone"
          >
          <span class="form-group__message" v-if="!$v.content.phone.minLength">手機號碼長度錯誤</span>
        </div>
        <br />
      </div>
      <div>
        <div class="input-group form-group m-y-0">
          <span class="input-group-addon">
            電子信箱
          </span>
          <input class="form-control form__input" placeholder="" type="email" maxlength="80"
                 v-model.trim="content.email" @input="$v.content.phone.$touch()">
          <span class="form-group__message" v-if="!$v.content.email.email">信箱格式錯誤</span>
        </div>
        <br />
      </div>
      <div>
        <div class="input-group">
          <span class="input-group-addon">
            生日
          </span>
          <date-time-picker :date="birth" :option="dateoption" :limit="dateLimit" class="form-date-picker w-100-p"></date-time-picker>
        </div>
        <br />
      </div>
      <div>
        <div class="input-group">
          <span class="input-group-addon b-r">
            性別
          </span>
          <div class="form-group text-left">
            <div class="radio inline-block">
              <label>
                <input type="radio" name="sexOption" value="1" v-model="content.sex">男
              </label>
            </div>
            <div class="radio inline-block">
              <label>
                <input type="radio" name="sexOption" value="2" v-model="content.sex">
                女
              </label>
            </div>
          </div>
        </div>
        <br />
      </div>
      <!-- up start -->
      <div  v-if="info">
        <div class="input-group">
        <span class="input-group-addon">
          停權
        </span>
          <div class="form-group">
            <select class="form-control" v-model="content.is_suspend">
              <option value="0">正常</option>
              <option value="1">停權</option>
            </select>
          </div>
        </div>
        <br />
      </div>
      <!-- up end -->
      <!-- /.box-body -->
    </div>
    <div class="box-footer text-center">
      <router-link to="/accountTable">
        <button class="btn btn-default">
          取消
        </button>
      </router-link>
      <button class="btn btn-success" v-if="!info" @click="addAccount">
        新增
      </button>
      <button class="btn btn-success" v-if="info" @click="upAccount">
        修改
      </button>
    </div>
    <br />
    <m-modal class="text-left" :option="delOption" @trigger="trigger"></m-modal>
  </div>
</template>
<script>
import matcherModal from '../../../elements/Modal.vue'
var sha256 = require('js-sha256').sha256
import datetimePicker from 'vue-datepicker/vue-datepicker-es6.vue'
import moment from 'moment'
import { required, minLength, maxLength, sameAs, email } from 'vuelidate/lib/validators'
import $ from 'jquery'
export default {
  props: {
    'info': {
      type: Object
    },
    'current': {
      type: Object
    },
    'brandList': {
      type: Array
    },
    'storeList': {
      type: Array
    },
    'posList': {
      type: Array
    }
  },
  components: {
    'date-time-picker': datetimePicker,
    'm-modal': matcherModal
  },
  data () {
    return {
      phone: '',
      radioRoleType: 'admin',
      delOption: {
        id: 'delModal',
        title: '刪除帳號',
        body: '確定刪除?<br>刪除此管理者，將無法再用此帳號登入！',
        btns: [
          {
            name: '取消'
          },
          {
            name: '確定',
            event: 'delManager'
          }
        ]
      },
      show: {
        delBtn: false
      },
      select: {
        bindingBrandList: [],
        bindingStoreList: [],
        bindingPosList: []
      },
      content: {
        account: '',
        password: '',
        re_password: '',
        name: '',
        phone: '',
        email: '',
        birth: '',
        sex: 0,
        is_suspend: 0,
        bindingBrandList: [],
        bindingStoreList: [],
        bindingPosList: []
      },
      birth: {
        time: ''
      },
      dateoption: {
        type: 'day',
        week: ['一', '二', '三', '四', '五', '六', '日'],
        month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        format: 'YYYY-MM-DD',
        placeholder: '',
        inputStyle: {
          'display': 'inline-block',
          'padding': '6px',
          'line-height': '22px',
          'font-size': '16px',
          'border': '1px solid #d2d6de',
          'border-radius': '0px 3px 3px 0px',
          'color': '#555'
        },
        color: {
          header: '#dd4b39',
          headerText: '#fff'
        },
        buttons: {
          ok: '確定',
          cancel: '取消'
        },
        overlayOpacity: 0.5, // 0.5 as default
        dismissible: true // as true as default
      },
      dateLimit: [
        {
          type: 'fromto',
          to: moment().format('YYYY-MM-DD')
        }
      ],
      brandName: '',
      brandType: '',
      brandBrief: [],
      storeBrief: [],
      posBrief: [],
      brandDefault: {
        value: 0,
        label: ''
      }
    }
  },
  validations: {
    content: {
      phone: {
        minLength: minLength(10),
        maxLength: maxLength(10)
      },
      password: {
        required
      },
      re_password: {
        required,
        sameAsPassword: sameAs('password')
      },
      email: {
        email
      }
    }
  },
  methods: {
    init () {
      if (!this.info) {
        this.getBrandBrief()
        this.getPosBrief()
      }
    },
    trigger (event) {
      if (event === 'delManager') {
        this.delManager()
      }
    },
    addAccount () {
      var self = this
      var url = '/manager/' + this.radioRoleType
      var info = this.content
      var data = {
        account: info.account,
        password: sha256(info.password),
        re_password: sha256(info.re_password),
        name: info.name
      }
      if (info.phone) data['phone'] = info.phone
      if (info.email) data['email'] = info.email
      if (this.birth.time) data['birth'] = this.birth.time
      if (info.sex) data['sex'] = info.sex
      // bindingBrandList: [],
      // bindingStoreList: []
      if (this.content.bindingBrandList.length && this.radioRoleType === 'brand') {
        var bList = []
        for (var i = 0; i < this.content.bindingBrandList.length; i++) {
          bList.push(parseInt(this.content.bindingBrandList[i].value, 10))
        }
        data['binding_brand_list'] = bList
      }
      if (this.content.bindingStoreList.length && this.radioRoleType === 'store') {
        var sList = []
        for (var j = 0; j < this.content.bindingStoreList.length; j++) {
          sList.push(parseInt(this.content.bindingStoreList[j].value, 10))
        }
        data['binding_store_list'] = sList
      }
      if (this.content.bindingPosList.length && this.radioRoleType === 'pos') {
        var pList = []
        for (var k = 0; k < this.content.bindingPosList.length; k++) {
          pList.push(parseInt(this.content.bindingPosList[k].value, 10))
        }
        data['binding_pos_list'] = pList
      }
      this.getDataH('post', url, data, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: response.data.message,
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          })
          self.$router.replace('/accountTable')
        }
      })
    },
    upAccount () {
      var self = this
      var url = '/manager/' + this.current.role_type + '/' + this.current.manager_id
      var info = this.content
      var data = {
        name: info.name,
        phone: info.phone,
        email: info.email,
        sex: info.sex,
        is_suspend: info.is_suspend
      }
      data['birth'] = this.birth.time
      if (info.bindingBrandList.length && this.current.role_type === 'brand') {
        var bList = []
        for (var i = 0; i < info.bindingBrandList.length; i++) {
          bList.push(parseInt(info.bindingBrandList[i].value, 10))
        }
        data['binding_brand_list'] = bList
      }
      if (info.bindingStoreList.length && this.current.role_type === 'store') {
        var sList = []
        for (var j = 0; j < info.bindingStoreList.length; j++) {
          sList.push(parseInt(info.bindingStoreList[j].value, 10))
        }
        data['binding_store_list'] = sList
      }
      if (this.content.bindingPosList.length && this.current.role_type === 'pos') {
        var pList = []
        for (var k = 0; k < info.bindingPosList.length; k++) {
          pList.push(parseInt(info.bindingPosList[k].value, 10))
        }
        data['binding_pos_list'] = pList
      }
      if (info.password && info.re_password) {
        data['password'] = sha256(info.password)
        data['re_password'] = sha256(info.re_password)
      }
      this.getDataH('put', url, data, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: response.data.message,
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          })
          self.$router.replace('/accountTable')
        }
      })
    },
    verityPhone () {
      var e = $('#phone')
      this.content.phone = e.val()
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/))
      }
    },
    getBrandBrief () {
      var self = this
      var url = '/brand/listBrief?is_delete=0&list_sort=name ASC'
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var bList = response.data.list
          for (let i = 0; i < bList.length; i++) {
            let obj = {label: bList[i].name, value: bList[i].brand_id}
            self.brandBrief.push(obj)
            if (i === 0) {
              if (!self.storeList) self.brandDefault = obj
              else {
                if (!self.storeList.length) self.brandDefault = obj
                else {
                  self.brandDefault.value = self.storeList[0].brand_id
                  const brandid = self.storeList[0].brand_id
                  for (let i = 0; i < bList.length; i++) {
                    if (bList[i].brand_id === brandid) self.brandDefault.label = bList[i].name
                  }
                }
              }
            }
          }
        }
      })
    },
    getStoreBrief (brandId) {
      this.storeBrief = []
      var self = this
      var url = '/brand/' + brandId + '/storeListBrief?&list_sort=name ASC'
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var sList = response.data.list
          for (let i = 0; i < sList.length; i++) {
            let obj = {label: sList[i].name, value: sList[i].store_id}
            self.storeBrief.push(obj)
          }
        }
      })
    },
    delManager () {
      var self = this
      var url = '/manager/' + this.$route.params.role_type + '/' + this.info.manager_id
      this.getDataH('delete', url, null, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: response.data.message,
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          })
          self.$router.replace('/accountTable')
        }
      })
    },
    getPosBrief () {
      this.posBrief = []
      var self = this
      var url = '/pos/vendorBriefList'
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var pList = response.data.list
          for (let i = 0; i < pList.length; i++) {
            let obj = {label: pList[i].name, value: pList[i].pos_vendor_id}
            self.posBrief.push(obj)
          }
        }
      })
    }
  },
  created () {
    this.init()
  },
  watch: {
    'select.bindingBrandList' () {
      this.content.bindingBrandList = this.select.bindingBrandList
    },
    'select.bindingStoreList' () {
      this.content.bindingStoreList = this.select.bindingStoreList
    },
    'select.bindingPosList' () {
      this.content.bindingPosList = [this.select.bindingPosList]
    },
    info () {
      /* update */
      const info = this.info
      const content = this.content
      content.name = info.name
      content.phone = info.phone
      content.email = info.email
      this.birth.time = info.birth
      content.sex = info.sex
      content.is_suspend = info.is_suspend
      if (info.account !== 'admin' && info.account !== 'matcher_admin') this.show.delBtn = true
      if (this.$route.params.role_type === 'pos') this.getPosBrief()
      else this.getBrandBrief()
    },
    'brandDefault.value' () {
      this.storeBrief = []
      this.bindingStoreList = []
      this.content.bindingStoreList = []
      this.getStoreBrief(this.brandDefault.value)
    },
    brandBrief () {
      var contentBList = []
      var bList = this.brandList
      if (bList) {
        for (var i = 0; i < bList.length; i++) {
          this.brandBrief.filter(function (elem, index, obj) {
            if (elem.value === bList[i]) {
              contentBList.push(elem)
            }
          })
        }
        this.content.bindingBrandList = contentBList
        this.select.bindingBrandList = contentBList
      }
    },
    storeBrief () {
      var contentSList = []
      if (this.storeList) {
        if (this.storeList.length) {
          var sList = this.storeList[0].binding_store_list
          if (sList) {
            for (var i = 0; i < sList.length; i++) {
              this.storeBrief.filter(function (elem, index, obj) {
                if (elem.value === sList[i]) {
                  contentSList.push(elem)
                }
              })
            }
            this.content.bindingStoreList = contentSList
            this.select.bindingStoreList = contentSList
          }
        }
      }
    },
    posBrief () {
      var contentPList = []
      var pList = this.posList
      if (pList) {
        for (var i = 0; i < pList.length; i++) {
          this.posBrief.filter(function (elem, index, obj) {
            if (elem.value === pList[i]) {
              contentPList.push(elem)
            }
          })
        }
        this.content.bindingPosList = contentPList
        this.select.bindingPosList = contentPList
      }
    }
  },
  computed: {
    getDataH () {
      return this.$parent.getDataH
    },
    bindStore () {
      var contentSList = []
      var sList = this.storeList
      if (sList) {
        for (var i = 0; i < sList.length; i++) {
          this.storeBrief.filter(function (elem, index, obj) {
            if (elem.value === sList[i]) {
              contentSList.push(elem)
            }
          })
        }
        return contentSList
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// AccountFormTemp.vue?14c5f9c2